import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

export const login = createAsyncThunk(
  "login/login",
  async (obj, { dispatch, getState }) => {
    let reqOptions = {};
    let headers = new Headers({
      "Cache-Control": "no-cache",
      Pragma: "no-cache",
      Expires: 0,
    });
    headers.set("Access-Control-Allow-Origin", "*");
    headers.append("Content-Type", "application/json");
    headers.append("Accept", "application/json");
    reqOptions.method = obj.method;
    //reqOptions.body = JSON.stringify(obj.body);
    reqOptions.headers=headers;
    return fetch("authentication/Login", reqOptions).then((r) => {
      
        return r.json();
      

    });
  }
);

const loginSlice = createSlice({
  name: "login",
  initialState: {
    //user: {}, 
    authenticated:false,
    status: null,   
    loading: true,
    isLoggedIn: false,
    loginStatus: null,
    redirectUrl: "",
  },
  reducers: {
   updateUser(state, { payload }){
     console.log(payload);
   // state.user=payload;
   }
  },
  // extraReducers: {
  

  //   [login.pending]: (state, action) => {
  //     state.status = "loading";
  //   },
  //   [login.fulfilled]: (state, { payload }) => {
     
  //     state.status = "success";
  //     let url = payload.url.replace("https", "http");
  //     console.log("url:", url);
  //     state.redirectUrl = url.replace("http", "https");
  //     state.isLoggedIn = true;
  //     state.loginStatus = "success";
  //     // if(payload){
  //     //   state.authenticated=true;
  //     //   state.user=payload;
  //     // }      
  //     // else
  //     // {
  //     //   state.authenticated=false;
  //     //   state.user={};
  //     // }
      
  //   },
  //   [login.rejected]: (state, action) => {
  //     state.status = "failed";
  //     state.authenticated=false;
  //       state.user={};
  //     console.log("Error from getRoles", action.error.message);
  //   },
  // },
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state, action) => {
        state.status = "loading";
      })
      .addCase(login.fulfilled, (state, { payload }) => {
        state.status = "success";
        let url = payload.url.replace("https", "http");
        console.log("url:", url);
        state.redirectUrl = url.replace("http", "https");
        state.isLoggedIn = true;
        state.loginStatus = "success";
        // if (payload) {
        //   state.authenticated = true;
        //   state.user = payload;
        // } else {
        //   state.authenticated = false;
        //   state.user = {};
        // }
      })
      .addCase(login.rejected, (state, action) => {
        state.status = "failed";
        state.authenticated = false;
        state.user = {};
        console.log("Error from getRoles", action.error.message);
      });
  },
  
});
export const { updateUser } = loginSlice.actions;
export default loginSlice.reducer;
